import "../Component3/css/Returnpolicy.css";
import SEO from "../SEO";
import { seoConfig } from "../config/seoConfig";
import logo from "../Component2/logo/hirelink.png";

function PrivacyPolicies() {
  return (
    <>
      <SEO
        title={seoConfig.e_privacy.title}
        description={seoConfig.e_privacy.description}
      />
      <div className="epp-body">
        <div
          className="epp-wrapper"
          style={{ backgroundImage: `url(${logo})` }}
        >
          <div className="epp-container">
            <h2 className="epp-title">
              Employer Privacy Policy – PharmaJobshireLink.com
            </h2>
            <h6
              className=""
              style={{ textAlign: "center", fontWeight: "bold" }}
            >
              Platform: PharmaJobshireLink (Website + Mobile Applications)
            </h6>

            <h3 className="epp-heading">1. Platform Purpose</h3>
            <p className="epp-text">
              Welcome to PharmaJobshireLink, a specialized
              <b>Pharma Job portal</b> fdesigned to connect pharmaceutical
              companies, HR professionals, recruiters, and hiring managers with
              qualified pharma candidates. We are committed to protecting
              employer data, maintaining confidentiality, and ensuring secure
              processing of all business and recruitment information submitted
              through our platform.
            </p>

            <p className="epp-text">
              This Employer Privacy Policy explains how we collect, use, store,
              and protect employer information when you access or use our pharma
              job portal via website, Android app, or iOS app. By registering or
              using our services, you agree to the practices described below.
            </p>

            <h3 className="epp-heading">
              2. Information We Collect from Employers
            </h3>
            <p className="epp-text">
              We collect only necessary and relevant data required to provide
              recruitment services efficiently.
            </p>
            <p className="epp-text">
              <b>A. Registration Information</b>
              <br></br>● Company name and business details
              <br></br>● Contact person name
              <br></br>● Official email address
              <br></br>● Mobile number
              <br></br>● Office address
              <br></br>● GST details (if applicable)
              <br></br>
              <br></br>
              <b>B. Account & Usage Data</b>
              <br></br>● Login credentials
              <br></br>● Staff account details created by employer
              <br></br>● Job posting information
              <br></br>● Resume download activity
              <br></br>● Subscription and payment history
              <br></br>
              <br></br>
              <b>C. Technical Data</b>
              <br></br>● Device information
              <br></br>● Browser type
              <br></br>● IP address
              <br></br>● App usage analytics
            </p>

            <h3 className="epp-heading">3. How We Use Employer Information</h3>
            <p className="epp-text">
              We use employer information strictly for operational and
              service-related purposes, including:
              <br></br>
              <br></br>● Providing access to our pharma job portal services{" "}
              <br></br>● Enabling employers to post pharma jobs <br></br>●
              Allowing employers to search and download candidate resumes{" "}
              <br></br>● Managing employer and staff accounts <br></br>●
              Processing payments and invoices <br></br>● Preventing fraud,
              misuse, or unauthorized activity <br></br>● Improving platform
              performance and user experience
            </p>
            <p className="epp-text">
              We <b>do not sell or rent employer data</b> to third parties for
              marketing purposes.
            </p>

            <h3 className="epp-heading">
              4. Resume Access & Candidate Data Usage
            </h3>
            <p className="epp-text">
              Employers may access candidate profiles and resumes only after
              payment of applicable charges.Employers agree:
            </p>
            <p className="epp-text">
              <br></br> ● To use candidate data strictly for recruitment
              purposes <br></br>● Not to copy, distribute, or resell candidate
              information <br></br>● Not to contact candidates for unrelated
              marketing or promotions
            </p>

            <p className="epp-text">
              Violation may result in account suspension or permanent
              termination.
            </p>

            <h3 className="epp-heading">5. Data Security Measures</h3>
            <p className="epp-text">
              We implement industry-standard security safeguards to protect
              employer information, including:
            </p>
            <p className="epp-text">
              <br></br>● Secure server infrastructure <br></br>● Encrypted login
              authentication <br></br>● Firewall protection <br></br>●
              Restricted database access <br></br>● Continuous monitoring for
              suspicious activity
            </p>
            <p className="epp-text">
              While we maintain strict safeguards, no online platform can
              guarantee absolute security. Employers are responsible for
              protecting their login credentials.
            </p>

            <h3 className="epp-heading">6. Payment Information Security</h3>
            <p className="epp-text">
              All payments on the pharma job portal are processed through secure
              payment gateways. We do{" "}
              <b>
                not store card details, banking PINs, or sensitive financial
                credentials
              </b>{" "}
              on our servers.
              <br></br>
              <br></br>Payment records retained are limited to:
            </p>
            <p className="epp-text">
              ● Transaction ID <br></br>● Amount paid <br></br>● Payment status{" "}
              <br></br>● Invoice details
            </p>

            <h3 className="epp-heading">7. Third-Party Services</h3>
            <p className="epp-text">
              We may use trusted third-party service providers for:
              <br></br>
              <br></br>Conditions:
              <br></br>
              <br></br>● Payment processing <br></br>● Cloud hosting <br></br>●
              Analytics <br></br>● Technical maintenance
              <br></br>
              <br></br>These providers are contractually obligated to protect
              employer data and use it only for authorized services.
            </p>

            <h3 className="epp-heading">8. Employer Responsibilities</h3>
            <p className="epp-text">
              Employers using PharmaJobshireLink agree:
              <br></br>
              <br></br>● To provide accurate company information <br></br>● Not
              to upload false or misleading job postings <br></br>● Not to
              misuse candidate data <br></br>● To maintain confidentiality of
              login credentials<br></br>
              <br></br>Such cases must be reported within 48 hours with valid
              proof.
              <br></br>
              <br></br>Any violation may lead to account suspension without
              notice.
            </p>

            <h3 className="epp-heading">9. Data Retention Policy</h3>
            <p className="epp-text">
              We retain employer information only as long as necessary for:
            </p>
            <p className="epp-text">
              ● Active account services <br></br>● Legal compliance <br></br>●
              Dispute resolution
              <br></br>● Fraud prevention
            </p>
            <p className="epp-text">
              Inactive accounts may be archived or deleted periodically to
              maintain system efficiency
            </p>

            <h3 className="epp-heading">10. Legal Compliance & Disclosure</h3>
            <p className="epp-text">
              We may disclose employer information if required:
              <br></br>
              <br></br>● By law or government authority <br></br>● To comply
              with legal proceedings <br></br>● To protect platform rights or
              safety <br></br>● To prevent fraudulent or illegal activity
            </p>

            <h3 className="epp-heading">11. Mobile App Privacy Compliance</h3>
            <p className="epp-text">
              Our Android and iOS applications comply with app-store privacy
              standards:
              <br></br>
              <br></br>● We collect only necessary business information{" "}
              <br></br>● We do not access contacts, media, or files without
              permission <br></br>● We do not track users outside the app
              without consent <br></br>● Permissions requested are strictly
              service-related
            </p>

            <h3 className="epp-heading">12. Cookies & Tracking Technologies</h3>
            <p className="epp-text">
              Our pharma job portal uses cookies and similar technologies to:
              <br></br>
              <br></br>● Maintain login sessions <br></br>● Improve user
              experience <br></br>● Analyze platform performance
              <br></br>
              <br></br>
              Employers may disable cookies in browser settings, but some
              features may not function properly.
            </p>

            <h3 className="epp-heading">13. Policy Updates</h3>
            <p className="epp-text">
              We may revise this Employer Privacy Policy at any time to reflect:
            </p>
            <p className="epp-text">
              ● Legal updates <br></br>● Security improvements <br></br>●
              Service changes
            </p>
            <p className="epp-text">
              Updated policies will be posted on this page with a revised
              effective date. Continued use of the platform indicates acceptance
              of the updated policy.
            </p>

            <h3 className="epp-heading">14. Contact Information</h3>
            <p className="epp-text">
              For privacy-related questions, data requests, or account concerns,
              employers may contact:
            </p>
            <p className="epp-text">
              <b>Support Team</b>
              <br></br>PharmaJobshireLink<br></br>Website:{" "}
              <a href=" https://pharmajobshirelink.com">
                {" "}
                https://pharmajobshirelink.com
              </a>
              <br></br>Email:{" "}
              <a href="info@pharmajobshirelink.com">
                {" "}
                info@pharmajobshirelink.com
              </a>
            </p>

            <h3 className="epp-heading">15. Acceptance of Policy</h3>
            <p className="epp-text">
              By registering as an employer or using our pharma job portal
              services, you confirm that:
              <br></br>
              <br></br>● You have read this Privacy Policy
              <br></br>● You understand how your data is used
              <br></br>● You agree to comply with all terms
            </p>
            <p className="epp-footer-text" style={{ fontWeight: "bold" }}>
              © {new Date().getFullYear()} All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicies;
